import { render, staticRenderFns } from "./BookingTab.vue?vue&type=template&id=2ac77ed1"
import script from "./BookingTab.vue?vue&type=script&lang=js"
export * from "./BookingTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports